import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-TimeCursor",
  "use": "icon-TimeCursor-usage",
  "viewBox": "0 0 464.72 828.79",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 464.72 828.79\" id=\"icon-TimeCursor\"><defs></defs><g id=\"icon-TimeCursor_图层_2\" data-name=\"图层 2\"><g id=\"icon-TimeCursor_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M461.67,808.1,248.18,559.4V0h-30V557.49L3.05,808.1a12.53,12.53,0,0,0,9.51,20.69h439.6A12.53,12.53,0,0,0,461.67,808.1Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol